export const KEY_LIST_STYLE_TYPE = 'listStyleType';

export const KEY_LIST_START = 'listStart';
